import { Form, Select } from 'antd';
import { selectHerePlaceholder } from '../../constants/translations';

export const SupSubSpecific = ({
  selectionOptions,
}: { selectionOptions: string[] }) => {
  return (
    <Form.Item
      label="Sutrikimai detaliau"
      name={['registration', 'supSubSpecific']}
      style={{ display: selectionOptions?.length > 0 ? 'block' : 'none' }}
    >
      <Select
        mode="multiple"
        placeholder={selectHerePlaceholder}
        showSearch={true}
      >
        {selectionOptions?.map((item, index) => (
          <Select.Option key={item} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};
